<script>

import {axios} from '../../mixins';
import MapBoxHeatMap from "../Geography/MapBoxHeatMap.vue";
import PriceChart from "../../chart/PriceChart.vue";

export default {

  name: 'PurchaseStatusChangeChart',

  props: {
    customerId: {
      required: true,
      type: Number,
    },

    customerTypes: {
      required: true,
      type: Object,
      default: function () {
        return {};
      },
    },

    outcomeTypes: {
      required: true,
      type: Object,
      default: function () {
        return {};
      },
    },

    purchaseStatuses: {
      required: true,
      type: Object,
      default: function () {
        return {};
      },
    },

    year: {
      required: true,
      type: Number,
    },

    mapboxToken: {
      type: String,
      required: true,
    },
  },

  filters: {
    roundToTwo(value) {
      return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },

  components: {MapBoxHeatMap, PriceChart},

  mixins: [axios],

  data() {
    return {
      customer: {},
      filter: {
        outcome_type_id: 0,
        customer_type_id: 2,
        start_date: this.year + '-01-01',
        end_date: (this.year + 1) + "-12-01",
        chartData: null,
        year: this.year,
      },
      hasPurchasesOfOutcomeType: {},
      loading: true,
    };
  },

  methods: {
    getData() {
      if (this.filter.year !== this.year) {
        this.filter.year = this.year
        this.filter.start_date = (this.year) + '-01-31'
        this.filter.end_date = (this.year + 1) + '-07-31'
      }
      this.loading = true;
      let route = '/customer/' + this.customerId + '/purchase-chart' + '?' + this.urlParams(this.filter);
      this.get(route).then((response) => {
        this.chartData = response.data.chartData
        this.hasPurchasesOfOutcomeType = response.data.hasPurchasesOfOutcomeType

        this.$refs['chart-1'].setData(this.chartData[this.filter.outcome_type_id])
        this.loading = false;
      })
    },
    changeData() {
      this.$refs['chart-1'].setData(this.chartData[this.filter.outcome_type_id])
    },
    urlParams(myData) {
      let out = [];
      for (let key in myData) {
        if (myData.hasOwnProperty(key)) {
          if (myData[key] !== null) {
            out.push(key + '=' + encodeURIComponent(myData[key]));
          }
        }
      }
      return out.join('&');
    },
  },
};

</script>

<template>
  <div class="light-mode">
    <div class="flex justify-between">
      <div class="text-3xl text-center font-semibold p-2 rounded-t-md tab-shadow bg-primary">
        Change Over Time
      </div>
    </div>
    <div class="w-full mb-4 bg-primary rounded-tr-md p-6 tile-shadow">
      <div class="w-full flex flex-col md:flex-row mb-4">
        <div class="flex flex-1">
          <div class="grid grid-cols-1 md:grid-cols-3 gap-2 my-auto w-full">
            <label hidden for="start_date">Outcome Type</label>
            <select name="outcome_type_id"
                   id="outcome_type_id"
                   v-model="filter.outcome_type_id"
                   @change="changeData"
                   class="bg-tertiary italic border-b border-grey-light w-full py-05 px-3 py-2 rounded-md leading-tight focus:outline-none focus:ring">
              <option v-for="(item, key) in this.outcomeTypes" :value="key">
                {{item}}
              </option>
            </select>

            <label hidden for="start_date">Start Date</label>
            <input type="date" name="start_date"
                   id="start_date"
                   v-model="filter.start_date"
                   @change="getData"
                   :max="filter.end_date"
                   class="bg-tertiary italic border-b border-grey-light w-full py-05 px-3 py-2 rounded-md leading-tight focus:outline-none focus:ring">

            <label hidden for="start_date">End Date</label>
            <input type="date" name="end_date"
                   id="end_date"
                   v-model="filter.end_date"
                   @change="getData"
                   :min="filter.start_date"
                   class="bg-tertiary italic border-b border-grey-light w-full py-05 px-3 py-2 rounded-md leading-tight focus:outline-none focus:ring">
          </div>
        </div>
      </div>

      <div v-show="this.loading" class="text-center text-2xl font-bold bg-primary p-4">Loading...</div>
      <div class="grid grid-cols-1 gap-3" v-show="!this.loading">
        <div class="bg-tertiary p-2 rounded-lg">
          <PriceChart
              chartId="purchase-percent_difference-chart-1"
              datasetIdKey="purchases-1"
              :height="150"
              cssClasses=""
              ref="chart-1"
          ></PriceChart>
        </div>
      </div>
    </div>
  </div>
</template>
